import i18next from 'i18next';

i18next.addResources('en', 'DistillationInformationModal', {
  stillOperator: 'Still Operator',
  distilledBy: 'Distilled By',
  minHydrometer: 'Min Hydrometer',
  maxHydrometer: 'Max Hydrometer'
});
